import React, { Component } from "react";
import PropTypes from "prop-types";
import ReactDataGrid from "react-data-grid";

import { Toolbar, Data, Filters } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, Button, ButtonToolbar, Breadcrumb } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import axios from 'axios';

import Spinner from '../../components/Widgets/spinner';
import checkPermission from '../Common/permissions';
import genericRadioFilter from '../Common/genericRadioFilter';
import dateFilterRadios from '../Common/dateFilterRadios';
import ContentWrapper from "../Layout/ContentWrapper";
import StringFormatter from "./booleanFormatter";
import GenericProductSuggest from "../../containers/Common/GenericProductSuggest";
import { toFromDates } from "../Common/cleanDates";
import { RMADateFormatter } from './rmaDateFormatter';
import ReactPaginate from 'react-paginate';
import GenericSelection from '../Common/GenericSelection';
import Select from 'react-select';
import checkPermissionLocal from '../Common/permissions'
import rmaModals from '../Common/modals/rma';
import { BD_RMA_URL } from "../../actions/url";
import { ROOT_URL, ROOT_API_URL } from '../../actions/root_url';;

const {
  NumericFilter,
  AutoCompleteFilter,
  MultiSelectFilter,
  SingleSelectFilter
} = Filters;


const processStatus = [{
  label: 'Unreceived',
  value: 'unreceived'
}, {
  label: 'Received',
  value: 'received',
}, {
  label: 'Checking',
  value: 'checking',
}, {
  label: 'Repairing',
  value: 'repairing',
}, {
  label: 'Complete',
  value: 'complete',
}];

const fixingStatus = [
  { label: 'UNRECEIVED', value: 'UNRECEIVED' },
  { label: 'RECEIVED', value: 'RECEIVED' },
  { label: 'REPAIRING', value: 'REPAIRING' },
  { label: 'REPAIRED', value: 'REPAIRED' },
  { label: 'DISPATCHED', value: 'DISPATCHED' },
];

const requestTypeOptions = [
  { value: 'relaunch', label: 'Relaunch' },
  { value: 'repair', label: 'Repair' },
];

const isFBD = ROOT_API_URL === 'https://fbd-scm.truckxi.com/api/' || ROOT_URL === 'https://fbd-scm.truckxi.com/api/';

const deleteRMA = (rmaId, success, failed) => {
  axios({
    url: `${ROOT_URL}v1/bd_rma/void/${rmaId}`,
    method: 'POST',
    data: {},
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
  })
    .then(res => {
      console.log('res', res);
      success();
    })
    .catch(err => {
      console.log('err', err);
      failed();
    })
}
const {
  Confirmation
} = rmaModals;
class RowRenderer extends Component {
  render() {
    // here we are just changing the style
    // but we could replace this with anything we liked, cards, images, etc
    // usually though it will just be a matter of wrapping a div, and then calling back through to the grid
    return (
      <div
        onDoubleClick={() => { this.props.onDoubleClick(this.props.row); }}
      >
        <ReactDataGrid.Row ref="row" {...this.props} />
      </div>
    );
  }
}

RowRenderer.PropTypes = {
  onDoubleClick: React.PropTypes.func,
};

class OptionsFilterRenderer extends Component {
  state = {
    selected: null,
  }
  handleChange = selected => {
    const {
      onChange,
      column
    } = this.props;
    this.setState({
      selected,
    })
    onChange({
      filterTerm: selected ? selected.value : selected,
      column: column,
    });
  };

  renderSelection = () => {
    const {
      onChange,
      column,
    } = this.props;
    if (column.filterable === false) {
      return <span />;
    }
    return (
      <Select
        clearable={true}
        value={this.state.selected}
        options={this.props.options}
        onChange={(selected) => {
          this.handleChange(selected)
        }}
      />
    );
  };
  render() {
    return (
      <div className="form-group">{this.renderSelection()}</div>
    );
  }
}

const generateFilterOptions = (options) => {
  return (props) => <OptionsFilterRenderer
    {...props}
    options={options} 
  />
}

class Rma extends Component {
  static contextTypes = {
    router: React.PropTypes.object
  };
  constructor() {
    super();
    this.state = {
      status: 'all',
      FromDate: undefined,
      ToDate: undefined,
      days: '1',
      search: '',
      productSearchType: 'ProductNum',
      rows: [],
      selectedRows: [],
      filters: {},
      sortColumn: null,
      sortDirection: null,
      path: null,
      filteredByItem: false,
      currentPage: 0,
      isDeleteConfirmationVisible: false,
    }
  }

  componentDidMount() {
    if (isFBD) {
      this.props.fetchCustomers(true);
    } else {
      this.props.fetchCustomers();
    }
    const fromDate = '1900-01-01';
    const toDate = '3000-01-01';
    const days = 1;
    const status = 'all';
    this.props.setDefaultDays('rma');
    this.props.setDefaultOfForm('status', 'all', 'rma');
    if (this.props.location.pathname === '/dispatchRMA') {
      this.props.fetchDispatchReturns(fromDate, toDate, days, status, this.state.currentPage + 1);
      this.setState({ path: 'dispatchRMA' })
    } else if (this.props.location.pathname === '/customerRMA') {
      this.props.fetchCustomerReturnsByFilter(fromDate, toDate, days, status, this.state.currentPage + 1, this.state.currentCustomer, this.state.search);
      this.setState({ path: 'customerRMA' })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.customerReturns !== nextProps.customerReturns) {
      ;
      this.setState({ rows: nextProps.customerReturns });
    }

    // if (nextProps.dispatchReturns.bd_rmas && this.props.dispatchReturns.bd_rmas !== nextProps.dispatchReturns.bd_rmas) {
    //   let rows = nextProps.dispatchReturns.bd_rmas;
    //   rows = rows.filter(r => r !== null);
    //   this.setState({ rows: rows })
    // }

    // if (nextProps.Days && nextProps.Days !== this.props.Days) {
    //   if (nextProps.Days !== -1) {
    //     this.props.setDefaultOfForm('FromDate', null, 'rma');
    //     this.props.setDefaultOfForm('ToDate', null, 'rma');
    //   }
    //   this.setState({ days: nextProps.Days });
    // }

    if (nextProps.Status && nextProps.Status !== this.props.Status) {
      this.refreshList(nextProps)
    }
  }

  refreshList = (nextProps) => {
    const { path } = this.state;
    const fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
    const toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
    let { days } = this.state;
    if (days == null) {
      days = 7;
    }
    if (path === 'customerRMA') {
      this.props.fetchCustomerReturnsByFilter(fromDate, toDate, days, nextProps.Status, this.state.currentPage + 1, this.state.currentCustomer, this.state.search)
    } else if (path === 'dispatchRMA') {
      this.props.fetchDispatchReturns(fromDate, toDate, days, nextProps.status, this.state.search);
    }
    this.setState({
      selectedRows: [],
    })
  }

  redirect = e => {
    e.preventDefault();
    let Id;
    if (this.state.selectedRows) {
      Id = this.state.selectedRows[0].Id;
    } else {
      return;
    }
    this.context.router.push(`/${this.state.path}/${Id}`);
  }

  handleRMADelete = (e) => {
    e.preventDefault();
    this.setDeleteConfirmationModalVisibility(true);
    // console.log('this.state.selectedRows', this.state.selectedRows, checkPermissionLocal('void_rma'));
    // this.state.selectedRows.length !== 1 || !checkPermissionLocal('void_rma')
  }

  setDeleteConfirmationModalVisibility = isDeleteConfirmationVisible => this.setState({ isDeleteConfirmationVisible });

  onDeleteConfirm = () => {
    const {
      selectedRows
    } = this.state;
    const Id = selectedRows.map(row => row.Id).join(',');
    deleteRMA(Id, () => {
      this.refreshList(this.props);
      this.setDeleteConfirmationModalVisibility(false);
    }, (err = 'UNKNOWN') => {
      alert(err);
      this.setDeleteConfirmationModalVisibility(false);
    });
  }

  createNew = e => {
    e.preventDefault();
    this.props.resetCurrentForm();
    this.context.router.push(`/${this.state.path}/new`);
  }

  setToDate = (e) => {
    if (e < this.state.FromDate) {
      return;
    }
    this.setState({ ToDate: e })
  }

  setFromDate = (e) => {
    if (e > this.state.ToDate) {
      return;
    }
    this.setState({ FromDate: e })
  }

  setToRangeSearch = () => {
    this.setState({ days: '-1' })
  }

  handleStatusFilterChange = (status) => {
    const { returnsFilter } = this.props;
    const { path } = this.state;
    if (!returnsFilter) {
      const fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
      const toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
      let { days } = this.state;
      if (!this.state.days) {
        days = 7;
      }
      this.setState({ status: status }, () => {
        if (path === 'customerRMA') {
          this.props.fetchCustomerReturnsByFilter(fromDate, toDate, days, status, this.state.currentPage + 1, this.state.currentCustomer, this.state.search)
        } else if (path === 'dispatchRMA') {
          this.props.fetchDispatchReturns(fromDate, toDate, days, status, this.state.search);
        }
      })
    } else {
      this.setState({ status: status }, () => { });
    }
  }

  exportData = () => {
    const { path, search, status } = this.state;
    let rmaURL;
    const fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
    const toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
    let { days } = this.state;
    if (!this.state.days) {
      days = 7;
    }
    const dates = toFromDates(days, fromDate, toDate);
    if (path === "dispatchRMA") {
      rmaURL = `${BD_RMA_URL}fix/search/export/?Bearer=${localStorage.getItem('token')}`;
    } else if (path === "customerRMA") {
      rmaURL = `${BD_RMA_URL}/search/export/?Bearer=${localStorage.getItem('token')}`;
    }
    return (
      <div>
        <Button
          style={{ marginLeft: 15 }}
          bsStyle="success"
          disabled={!this.state.rows}
          href={rmaURL}>
          <em className="fa fa-arrow-circle-o-down" />
          <Translate value="excel" />
        </Button>
      </div>
    )
  }

  fetchReturnsByDetails = (days) => {
    const { path } = this.state;
    let FromDate = '1900-01-01';
    let ToDate = '3000-01-01';
    if (this.state.FromDate != null) {
      FromDate = this.formatDate(this.state.FromDate);
    }
    if (this.state.ToDate != null) {
      ToDate = this.formatDate(this.state.ToDate);
    }
    if (days === '-1' || days === -1) {
      this.setState({ days }, () => {
        if (path === 'customerRMA') {
          this.props.fetchCustomerReturnsByFilter(FromDate, ToDate, days, this.state.status, this.state.currentPage + 1, this.state.currentCustomer, this.state.search)
        } else if (path === 'dispatchRMA') {
          this.props.fetchDispatchReturns(FromDate, ToDate, days, this.state.status, this.state.search)
        }
      })
    } else {
      this.setState({ days: days, FromDate: null, ToDate: null }, () => {
        if (path === 'customerRMA') {
          this.props.fetchCustomerReturnsByFilter(FromDate, ToDate, days, this.state.status, this.state.currentPage + 1, this.state.currentCustomer, this.state.search)
        } else if (path === 'dispatchRMA') {
          this.props.fetchDispatchReturns(FromDate, ToDate, days, status, this.state.search)
        }
      })
    }
    this.setState({ selectedRows: [], days: days });
  }

  onEnter = (e) => {
    console.log('e', e);
    if (e.charCode === 13) {
      this.fetchSearchReturns()
    } else {
      return false
    }
  }

  fetchSearchReturns = () => {
    const { path, status, days } = this.state;
    let FromDate = '1900-01-01';
    let ToDate = '3000-01-01';
    if (this.state.FromDate != null) {
      FromDate = this.formatDate(this.state.FromDate);
    }
    if (this.state.ToDate != null) {
      ToDate = this.formatDate(this.state.ToDate);
    }
    if (path === 'customerRMA') {
      this.props.fetchCustomerReturnsByFilter(FromDate, ToDate, this.state.days, status, this.state.currentPage + 1, this.state.currentCustomer, this.state.search)
    } else if (path === 'dispatchRMA') {
      // this.props.fetchDispatchReturns(FromDate, ToDate, days, status, this.state.search)
    }
  }

  renderSearch = (e) => {
    // let { days } = this.state;
    // if (!this.state.days) {
    //   days = 7;
    // }
    // let { status } = this.state;
    // const { path } = this.state;
    // const fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
    // const toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
    return (<div className="control-dropdown-rma">
      <GenericProductSuggest
        value={this.state.search}
        onChange={(e, { newValue }) => {
          this.setState({ search: newValue });
        }}
        onKeyPress={(e) => this.onEnter(e)}
      />
    </div>)
    // if (!this.state.filteredByItem) {
    //   return (
    //     <div className="control-dropdown-rma">
    //       <GenericProductSuggest
    //         value={this.state.search}
    //         onChange={(e, { newValue }) => {
    //           this.setState({ search: newValue });
    //         }}
    //         onKeyPress={(e) => this.onEnter(e)}
    //       />
    //     </div>
    //   )
    // }
    // return (
    //   <div className="control-dropdown-rma" id="suggestion-box">
    //     {this.state.search}
    //     <em
    //       className="fa fa-times pull-right"
    //       onClick={() => {
    //         this.setState({ filteredByItem: false, search: '' }, () => {
    //           this.props.fetchCustomerReturnsByFilter(fromDate, toDate, days, status, this.state.currentPage, this.state.currentCustomer);
    //         });
    //       }}
    //     />
    //   </div>
    // )
  }

  formatDate(date) {
    let formattedDate = `${date.getFullYear()}-`;
    formattedDate += `${date.getMonth() + 1}-`;
    if (date.getDate() < 10) {
      formattedDate += `0${date.getDate()}`;
    } else {
      formattedDate += date.getDate();
    }
    return formattedDate;
  }

  changeRMAStatus = (status) => {
    const {
      selectedRows,
    } = this.state;
    // const { Id } = selectedRows[0];
    const Ids = [];
    selectedRows.forEach(row => {
      Ids.push(row.Id);
    })
    const success = () => {
      alert('success');
      this.setState({
        selectedRows: [],
      })
      this.fetchSearchReturns();
    }
    const failed = () => {
      alert('failed');
    }
    this.props.changeRMAStatus(Ids.join(','), status, success, failed)
  }

  renderTable() {
    if (this.props.isLoading && !this.props.error) return <Spinner />;
    else if (this.props.error) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger">{JSON.stringify(this.props.error)}</div>
        </ContentWrapper>
      );
    }

    // Parameters of the react-data-grid

    const tableHeight = window.innerHeight < 930 ? 570 : 570;

    const getRows = () => Data.Selectors.getRows(this.state);
    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const onRowClick = (rowIdx, row) => {
      if (rowIdx !== -1) {
        const rows = getRows();
        rows.map((r) => {
          r.isSelected = false;
        });
        rows[rowIdx].isSelected = true;
        this.setState({ rows, selectedRows: [rows[rowIdx]] });
      }
    };

    const onCellSelected = (coordinates) => {
      // console.log('coordinates', coordinates);
      // const rows = getRows();
      // rows.map((r) => {
      // r.isSelected = false;
      // });
      // rows[coordinates.rowIdx].isSelected = true;
      // this.setState({ rows, selectedRows: [...this.state.selectedRows, rows[coordinates.rowIdx]] });
    };

    const onClearFilters = () => {
      this.setState({ filters: {} });
    };

    // Handle the sortable function

    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state, { sortColumn, sortDirection });
      this.setState(state);
    };

    const handleFilterChange = (filter) => {
      const { rows } = this.state;
      if (rows && rows.length !== 0) {
        rows.map((row) => {
          row.Dropship = row.IsDropship ? 'yes' : 'no';
        });
      }
      this.setState({ rows });
      const newFilters = Object.assign({}, this.state.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      this.setState({ filters: newFilters });
    };

    const onRowsSelected = (rows) => {
      const newRows = getRows();
      const selectedRows = [...this.state.selectedRows, ...rows.map(r => r.row)];
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = true;
      });
      this.setState({ rows: newRows, selectedRows });
    };
    const onRowsDeselected = (rows) => {
      const newRows = [...this.state.rows];
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = false;
      });
      const selectedRows = [];
      newRows.forEach(row => {
        if (row.isSelected) {
          selectedRows.push(row);
        }
      })

      this.setState({ rows: newRows, selectedRows });
    };

    const columns = [
      {
        key: 'RMANum',
        name: <Translate value="rma_num" />,
        resizable: true,
        sortable: true,
        width: 180,
        filterable: true,
      },
      {
        key: 'CustomerName',
        name: <Translate value="customer_name" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      },
      {
        key: 'SKU',
        name: <Translate value="sku" />,
        resizable: true,
        sortable: true,
        width: 130,
        filterable: true,
      },
      {
        key: 'SNNum',
        name: <Translate value="sn_num" />,
        resizable: true,
        sortable: true,
        width: 130,
        filterable: true,
      },
      {
        key: 'RequestType',
        name: <Translate value="request_type" />,
        resizable: true,
        sortable: true,
        width: 130,
        filterable: true,
        filterRenderer: generateFilterOptions(requestTypeOptions),
      },
      {
        key: 'ReturnTracking',
        name: <Translate value="return_tracking" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      },
      {
        key: 'ProcessStatus',
        name: <Translate value="proccess_status" />,
        // formatter: StringFormatter,
        resizable: true,
        sortable: true,
        width: 130,
        filterable: true,
        filterRenderer: generateFilterOptions(processStatus),
      },
      {
        key: 'Status',
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: 'TotalPrice',
        name: <Translate value="total_price" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 120,
      },
      {
        key: 'CreateTime',
        name: <Translate value="create_date" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
        formatter: RMADateFormatter
      },
    ];

    // React Table Purchase Order Full Table
    return (
      <Row>
        <Col xs={12}>
          <div id="PurchaseOrderList-dataGrid1">
            <ReactDataGrid
              rowRenderer={
                <RowRenderer
                  onDoubleClick={({ Id }) => {
                    this.context.router.push(`/${this.state.path}/${Id}`);
                  }}
                />
              }
              rowKey="RMA_num"
              enableCellSelect
              onClearFilters={onClearFilters}
              onGridSort={handleGridSort}
              toolbar={<Toolbar enableFilter />}
              onAddFilter={handleFilterChange}
              columns={columns}
              rowHeight={25}
              headerRowHeight={45}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              minHeight={tableHeight}
              enableRowSelect="multi"
              onRowUpdated={this.handleRowUpdated}
              rowSelection={{
                showCheckbox: true,
                onRowsSelected,
                onRowsDeselected,
                selectBy: {
                  isSelectedKey: 'isSelected',
                },
              }}
              onRowClick={onRowClick}
              onCellSelected={onCellSelected}
            />
          </div>
        </Col>
      </Row>
    );
  }

  renderPagination = () => {
    const handleOnPageChange = ({ selected }) => {
      this.setState({
        currentPage: selected,
      }, () => [
        this.fetchSearchReturns(),
      ]);
    };

    return <Row>
      <Col md={12} >
        <div style={{ width: '630px' }} id="react-pagination">
          <ReactPaginate
            previousLabel={<Translate value="prev_page" />}
            nextLabel={<Translate value="next_page" />}
            containerClassName={'pagination'}
            activeClassName={'active'}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            pageCount={this.props.pages}
            onPageChange={handleOnPageChange}
            forcePage={this.state.currentPage}
          />
        </div>
      </Col>
    </Row>
  }

  generateExportURL = () => {
    const {
      fromDate,
      toDate,
      days,
      currentCustomer,
      selectedRows,
    } = this.state;
    const dates = toFromDates(days, fromDate, toDate);
    const ids = [];
    selectedRows.forEach(row => {
      ids.push(row.Id);
    });
    let url = `${ROOT_URL}v1/bd_rma/export?Bearer=${localStorage.getItem('token')}`
    if (ids.length) {
      url = `${url}&rma_ids=${ids.join(',')}`
    } else {
      if (currentCustomer) {
        url = `${url}&customer_id=${currentCustomer.value}`
      }
      url = `${url}&start__date=${dates.fromDate}&end_date=${dates.toDate}`
    }
    return url;
  }

  render() {

    return (
      <ContentWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="rma" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value={this.state.path === 'dispatchRMA' ? "dispatch_rma" : "customer_rma"} />
          </Breadcrumb.Item>
        </Breadcrumb> {/* End Navigation Trail */}
        <Grid id="purchase-order-list">
          <Row>
            <Col xs={12}>
              <Panel id="date-range-picker" className="form-horizontal">
                <Row>
                  {/* <Col xs={2}>
                    <h3 className="filter-title">
                      <Translate value="order_status" />
                      <span className="colon">:</span>
                    </h3>
                  </Col>
                  <Col xs={10}>
                    <div id="statusFilterRadios" className="form-horizontal">
                      {genericRadioFilter({
                        content: [
                          {
                            option: 'all',
                            id: 'all-radio-filter',
                            name: 'statusFilterRadios',
                            labelName: 'all',
                          },
                          {
                            option: 'Unreceived',
                            id: 'unreceived-radio-filter',
                            name: 'statusFilterRadios',
                            labelName: 'unreceived',
                          },
                          {
                            option: 'Received',
                            id: 'received-radio-filter',
                            name: 'statusFilterRadios',
                            labelName: 'received',
                          },
                          {
                            option: 'Repairing',
                            id: 'repairing-radio-filter',
                            name: 'statusFilterRadios',
                            labelName: 'repairing',
                          },
                          {
                            option: 'Repaired',
                            id: 'repaired-radio-filter',
                            name: 'statusFilterRadios',
                            labelName: 'repaired',
                          },
                          {
                            option: 'Dispatched',
                            id: 'dispatched-radio-filter',
                            name: 'statusFilterRadios',
                            labelName: 'dispatched',
                          },
                        ],
                        value: this.state.status,
                        handleOnClick: this.handleStatusFilterChange,
                        type: 'buttons',
                      })}
                    </div>
                  </Col> */}
                  <Col xs={2}>
                    <h3 className="filter-title">
                      <Translate value="order_date" />
                      <span className="colon">:</span>
                    </h3>
                  </Col>
                  <Col xs={10}>
                    {dateFilterRadios({
                      handleOnClick: this.fetchReturnsByDetails,
                      setToRangeSearch: this.setToRangeSearch,
                      setFromDate: this.setFromDate,
                      setToDate: this.setToDate,
                      FromDate: this.state.FromDate,
                      ToDate: this.state.ToDate,
                      Days: this.state.days,
                    })}
                  </Col>
                </Row>
                {/* <Row>
                  <Col xs={2}>
                    <h3 className="filter-title">
                      <Translate value="order_date" />
                      <span className="colon">:</span>
                    </h3>
                  </Col>
                  <Col xs={2}>
                    <Select
                      clearable={true}
                      value={this.state.currentCustomer}
                      options={this.props.customerOptions}
                      onChange={(currentCustomer) => {
                        this.setState({
                          currentCustomer,
                        }, () => {
                          this.fetchSearchReturns();
                        });
                      }}
                    />
                  </Col>
                </Row> */}
              </Panel>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <Panel className="position-relative table-collapse-fix" style={{ height: '740px' }}>
                <Row>
                  <Col xs={12}>
                    <ButtonToolbar className="table-buttons-rma">
                      <Button
                        bsStyle="success"
                        type="submit"
                        onClick={(e) => this.createNew(e)}
                      >
                        <em className="fa fa-plus" />
                        <Translate value="create" />
                      </Button>
                      <Button
                        bsStyle="warning"
                        type="button"
                        onClick={e => this.redirect(e)}
                        disabled={this.state.selectedRows.length !== 1}
                      >
                        <em className="fa fa-pencil" />
                        <Translate value="edit" />
                      </Button>
                      <Button
                        bsStyle="danger"
                        type="button"
                        onClick={e => this.handleRMADelete(e)}
                        disabled={!this.state.selectedRows.length || !checkPermissionLocal('void_rma')}
                      >
                        <em className="fa fa-trash" />
                        <Translate value="void" />
                      </Button>
                      <Button
                        bsStyle="warning"
                        type="button"
                        // onClick={e => this.h(e)}
                        href={this.generateExportURL()}
                      // disabled={this.state.selectedRows.length !== 1}
                      >
                        <em className="fa fa-download" />
                        <Translate value="export" />
                      </Button>
                      <Button
                        bsStyle="primary"
                        type="button"
                        href="https://truckxi-public-bucket.s3.us-west-1.amazonaws.com/storage/49032580-16d4-4232-8ed0-1c9d76ae8045.csv"
                      >
                        <em className="fa fa-download" />
                        <Translate value="tempalte_download" />
                      </Button>
                      <Button
                        bsStyle="primary"
                        type="button"
                        onClick={() => {
                          this.refs.rmaUploadRef.click();
                        }}
                      >
                        <em className="fa fa-download" />
                        <Translate value="import" />
                      </Button>
                      <Button
                        bsStyle="primary"
                        type="submit"
                        // disabled={!this.state.search}
                        onClick={(e) => this.fetchSearchReturns(e)}>
                        <em className="fa fa-plus" />
                        <Translate value="search" />
                      </Button>
                      <Col xs={4}>
                        <Row>
                          <Col xs={5}>{this.renderSearch()}</Col>
                          <Col xs={1} />
                          <Col xs={6}>
                            <Row>
                              <Col xs={4}>Customer: </Col>
                              <Col xs={8}>
                                <Select
                                  clearable={true}
                                  value={this.state.currentCustomer}
                                  options={this.props.customerOptions}
                                  onChange={(currentCustomer) => {
                                    this.setState({
                                      currentCustomer,
                                    }, () => {
                                      this.fetchSearchReturns();
                                    });
                                  }}
                                />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    </ButtonToolbar>
                  </Col>
                </Row>
                <Row style={{ marginTop: '8px' }}>
                  <Col sm={10}>
                    <ButtonToolbar className="table-buttons">
                      <Button
                        bsStyle="primary"
                        type="submit"
                        disabled={!this.state.selectedRows.length}
                        onClick={(e) => this.changeRMAStatus('received')}>
                        <Translate value="received" />
                      </Button>
                      <Button
                        bsStyle="primary"
                        type="submit"
                        disabled={!this.state.selectedRows.length}
                        onClick={(e) => this.changeRMAStatus('checking')}>
                        {/* <em className="fa fa-plus" /> */}
                        <Translate value="checking" />
                      </Button>
                      <Button
                        bsStyle="primary"
                        type="submit"
                        disabled={!this.state.selectedRows.length}
                        onClick={(e) => this.changeRMAStatus('repairing')}>
                        {/* <em className="fa fa-plus" /> */}
                        <Translate value="repairing" />
                      </Button>
                      <Button
                        bsStyle="primary"
                        type="submit"
                        disabled={!this.state.selectedRows.length}
                        onClick={(e) => this.changeRMAStatus('complete')}>
                        {/* <em className="fa fa-plus" /> */}
                        <Translate value="complete" />
                      </Button>
                    </ButtonToolbar>
                  </Col>
                </Row>
                {/* <Row>
                    <Col sm={4}>
                      <GenericSelection
                        options={this.props.customerOptions}
                        value={this.state.currentCustomer}
                        setSelected={(currentCustomer) => {
                          this.setState({
                            currentCustomer,
                          }, () => {
                            this.fetchSearchReturns();
                            // this.props.fetchCustomerReturnsByFilter()
                          });
                        }}
                        translation={<Translate value="customer_selection" />}
                      />
                    </Col>
                  </Row> */}
                {this.renderTable()}
                {this.renderPagination()}
              </Panel>
            </Col>
          </Row>
        </Grid>
        <Confirmation
          setModalVisibility={this.setDeleteConfirmationModalVisibility}
          isVisible={this.state.isDeleteConfirmationVisible}
          onConfirm={this.onDeleteConfirm}
        />
        <input
          type="file"
          ref="rmaUploadRef"
          style={{ display: 'none' }}
          accept=".csv"
          onChange={e => {
            const formData = new FormData();
            formData.append("rma_file", e.target.files[0]);
            this.props.uploadRMA(formData, this.refreshList);
          }}
        />
      </ContentWrapper>
    )
  }
}

export default Rma;



// WEBPACK FOOTER //
// ./master/jsx/components/RMA/rma.jsx